import './blogsBlock.scss'
import {getPropsFromState} from "../../redux/mapStateToProps";
import {
    GetBlog,
    GetBlogCategory,
} from "../../redux/actions";
import {connect} from "react-redux";
import React, {useEffect, useState} from "react";
import {generateFileMediaUrl} from "../../utils/generateMediaUrl";
import moment from "moment";
import {Link} from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";
import {getUrlWithLocal} from "../../utils/getUrlWithLocal";


 function BlogsBlock(props) {
     const {blogsCategory,blogs,staticTexts,selectedLanguage} = props
     const [activeCategory,setActiveCategory] = useState([]);

     useEffect(() => {
         props.GetBlogCategory()
     }, [selectedLanguage?.id])

     useEffect(() => {
         window.scrollTo({
             top: 0,
             behavior: "smooth"
         });

        loadMoreItems()
     }, [activeCategory])

     function changeCategory(id) {
         const newCategory = activeCategory.includes(id) ? activeCategory.filter(f => f !== id) : activeCategory.concat(id)
         setActiveCategory(newCategory)
     }

     function loadMoreItems() {
          props.GetBlog({
             offset: blogs?.length,
             categories:activeCategory
         })
     }

    return <div className="blogs-block">
        <div className={'blogs_list_header'}>
            ART <span className={'middle'}>RESIDENCE</span> <span className={'last'}>{staticTexts?.blog_list_page_title}</span>
        </div>
        <div className={'blogs_list_wrapper'}>
           <div className={'blogs_list_left'}>
               <InfiniteScroll
                   hasMore={blogs?.hasMore}
                   loadMore={loadMoreItems}
                   className={'blogs-list'}
                   pageStart={0}
                   threshold={500}
                   initialLoad={false}>
                   {
                       blogs?.blogList?.map(item => {
                           return <Link to={getUrlWithLocal(`/blogs/${item?.slug}`)} className={'blog_item'} key={item?.id}>
                               <div className={'blog_item_image'}>
                                   <img src={generateFileMediaUrl(item?.mediaMain?.path)}
                                        className="blog-image"
                                        title={item?.mediaMain?.title ? item?.mediaMain?.title : ''}
                                        alt={item?.mediaMain?.altAttribute ? item?.mediaMain?.altAttribute : ''}/>
                               </div>
                               <div className={'blog_content'}>
                                   <div className={'blog_data'}>
                                       {moment(item.data).format('MMMM DD, YYYY')}
                                   </div>
                                   <div className={'blog_title'}>
                                       {item?.title}
                                   </div>
                                   <div className={'blog_subtitle'}>
                                       {item?.subtitle}
                                   </div>
                                   <div className={'blog_category'}>
                                       {
                                           item?.categories?.map(category => {
                                               return <span>#{category?.title}</span>
                                           })
                                       }
                                   </div>
                               </div>
                           </Link>
                       })
                   }
               </InfiniteScroll>
           </div>
            <div className={'blogs_list_right'}>
                <div className={'list_right_title'}>
                    {staticTexts?.blog_list_category_title}
                </div>
                <div className={'category_list'}>
                    <div className={`category_item ${activeCategory?.length < 1 ? 'active' : ''}`}
                         onClick={() => setActiveCategory([])}>
                        #{staticTexts?.blog_detail_link_text}
                    </div>
                    {
                        blogsCategory?.map(category => {
                            return <div className={`category_item ${activeCategory.includes(category?.id) ? 'active' : ''}`}
                                        key={category?.id}
                                        onClick={() => changeCategory(category?.id)}
                            >
                                #{category?.title}
                            </div>
                        })
                    }
                </div>
            </div>
        </div>
    </div>
}
const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'blogs',
    'blogsCategory',
    'selectedLanguage'
]);

const mapDispatchToProps = {
    GetBlogCategory,
    GetBlog
};

export default connect(mapStateToProps, mapDispatchToProps)(BlogsBlock);